export default __webpack_public_path__ + "static/new-hero-Background-ffe1cc5522f5b5876e11df4a45ca4edc.png";